import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Box, Chip, Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';

export default function InfoBox(props) {
    const [isContactInfoOpen, setIsContactInfoOpen] = useState(true);
    const [isAbilityHubOpen, setIsAbilityHubOpen] = useState(true);
    const [isNotesOpen, setIsNotesOpen] = useState(true);

    const showPhoneList = (phoneString) => {
        const phoneArray = phoneString.split(",");

        return phoneArray.map((phone, index) => {
            return (
                <div key={index} className="d-flex align-items-center mb-2">
                    <div style={{
                        width: 20,
                        height: 20,
                        borderRadius: '50%',
                        backgroundColor: 'gray',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                        fontSize: 14,
                        marginRight: 10
                    }}>
                        {index + 1}
                    </div>
                    <div>{phone.trim()} - {index <= 0 ? 'Mobile' : 'Work'}</div>
                </div>
            );
        });
    };

    return (
        <>
            {/* Contact Info Section */}
            <div style={{ backgroundColor: 'white', borderRadius: 10, marginTop: 20, marginBottom: 20, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: 5 }}>
                    <h5 style={{ margin: 10 }}>Contact Details:</h5>
                    <i style={{ fontSize: 20, margin: 10 }} onClick={() => setIsContactInfoOpen(!isContactInfoOpen)} className={isContactInfoOpen ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                </div>
                {isContactInfoOpen &&
                    <div style={{ marginTop: -15, paddingBottom: 10 }}>
                        <hr style={{ background: "lightgray" }} />
                        <div style={{ marginLeft: 20, marginRight: 20, marginBottom: 5 }}>
                            <div style={{ marginBottom: 5 }}>
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>PHONE:</h6>
                                <span style={{ marginLeft: 6 }}>{showPhoneList(props.data.con_phone)}</span>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>EMAIL:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.con_email ? props.data.con_email : '-'}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>ADDRESS:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.con_Addr_line1}, {props.data.con_Addr_line2 ? `${props.data.con_Addr_line2},` : ''} {props.data.con_city}, {props.data.con_state}, {props.data.con_zip}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>STATUS:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.con_status}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>TYPE:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.con_contact_type}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>RELATED CUSTOMER:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.cus_name ? props.data.cus_name : '-'}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>FIRST CONTACT DATE:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{moment(props.data.con_first_contact_date).format('DD MMMM, YYYY')}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>LAST CONTACT DATE:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{moment(props.data.con_last_contact_date).format('DD MMMM, YYYY')}</h6>
                            </div>
                            <div style={{ marginBottom: 5 }} className="d-flex">
                                <h6 style={{ color: 'gray', display: 'inline-block', marginRight: 4 }}>PREFERRED COMM. MODE:</h6>
                                <h6 style={{ marginLeft: 6, display: 'inline-block' }}>{props.data.prefCommMode ? props.data.prefCommMode : '-'}</h6>
                            </div>
                        </div>
                    </div>
                }
            </div>

            {/* Ability Hub Section */}
            {props.user.subs.find((setting) => setting.feature_id === 22) && (
                <div style={{ backgroundColor: 'white', borderRadius: 10, marginTop: 20, marginBottom: 20, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', margin: 5 }}>
                        <h5 style={{ margin: 10 }}>Ability Hub:</h5>
                        <i style={{ fontSize: 20, margin: 10 }} onClick={() => setIsAbilityHubOpen(!isAbilityHubOpen)} className={isAbilityHubOpen ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                    </div>
                    {isAbilityHubOpen &&
                        <div style={{ marginTop: -15, paddingBottom: 10 }}>
                            <hr style={{ background: "lightgray" }} />
                            <div style={{ marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
                                <Box sx={{ 
                                    border: '1px solid #e0e0e0', 
                                    borderRadius: '8px',
                                    padding: '16px',
                                    backgroundColor: '#fafafa'
                                }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 2, color: '#424242' }}>
                                        ABILITY HUB
                                    </Typography>

                                    {/* Ability Hub Sync Status */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                        <Typography variant="body2" sx={{ fontSize: '0.875rem', mr: 1 }}>
                                            ABILITY HUB SYNC
                                        </Typography>
                                        <Chip 
                                            label="Synced" 
                                            size="small" 
                                            sx={{ 
                                                backgroundColor: '#4caf50', 
                                                color: 'white',
                                                height: '20px',
                                                fontSize: '0.75rem',
                                                fontWeight: 500
                                            }} 
                                        />
                                    </Box>

                                    {/* Connection Status */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                                        <Typography variant="body2" sx={{ fontSize: '0.875rem', mr: 1 }}>
                                            Connection Status:
                                        </Typography>
                                        <CheckCircleIcon sx={{ fontSize: 18, color: '#1976d2' }} />
                                    </Box>

                                    {/* Out of Sync Warning */}
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, gap: 1 }}>
                                        <WarningIcon sx={{ fontSize: 18, color: '#ff9800' }} />
                                        <Typography variant="body2" sx={{ fontSize: '0.875rem', color: '#424242' }}>
                                            Out of Sync
                                        </Typography>
                                        <a 
                                            href="#" 
                                            style={{ 
                                                fontSize: '0.875rem', 
                                                color: '#1976d2',
                                                textDecoration: 'none'
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                // Add your Ability Hub link logic here
                                                window.open('https://abilityhub.com', '_blank');
                                            }}
                                        >
                                            View in Ability Hub
                                        </a>
                                    </Box>

                                    {/* Go to Profile Button */}
                                    <Button 
                                        variant="contained" 
                                        fullWidth
                                        sx={{ 
                                            textTransform: 'none',
                                            backgroundColor: '#1976d2',
                                            '&:hover': {
                                                backgroundColor: '#1565c0'
                                            }
                                        }}
                                        onClick={() => {
                                            // Add your profile navigation logic here
                                            console.log('Navigate to profile');
                                        }}
                                    >
                                        Go to Profile
                                    </Button>

                                    {/* Invites Section (if needed) */}
                                    {props.AH_Invites && props.AH_Invites.length > 0 && (
                                        <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid #e0e0e0' }}>
                                            <Typography variant="caption" sx={{ color: 'gray', display: 'block', mb: 1 }}>
                                                Invitations:
                                            </Typography>
                                            {props.AH_Invites.map((inv, index) => {
                                                return (
                                                    <div key={index} className="d-flex align-items-center mb-2">
                                                        <div style={{
                                                            width: 20,
                                                            height: 20,
                                                            borderRadius: '50%',
                                                            backgroundColor: 'gray',
                                                            color: 'white',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
                                                            fontSize: 14,
                                                            marginRight: 10
                                                        }}>
                                                            {index + 1}
                                                        </div>
                                                        <span style={{ fontSize: '0.813rem' }}>
                                                            {`Invited to join circle of care for ${inv.PatientName} on ${moment(inv.addedOn).format('MM/DD/YYYY hh:mm A')} (${inv.confirmedOn ? `Confirmed` : `Sent`})`}
                                                        </span>
                                                    </div>
                                                );
                                            })}
                                        </Box>
                                    )}
                                </Box>
                            </div>
                        </div>
                    }
                </div>
            )}

            {/* Notes Section */}
            <div style={{ backgroundColor: 'white', borderRadius: 10, marginTop: 20, marginBottom: 20, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: 5 }}>
                    <h5 style={{ margin: 10 }}>Notes:</h5>
                    <i style={{ fontSize: 20, margin: 10 }} onClick={() => setIsNotesOpen(!isNotesOpen)} className={isNotesOpen ? "fa fa-chevron-up" : "fa fa-chevron-down"}></i>
                </div>
                {isNotesOpen &&
                    <div style={{ marginTop: -15, paddingBottom: 10 }}>
                        <hr style={{ background: "lightgray" }} />
                        <div style={{ marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
                            <div style={{ marginBottom: 20 }}>
                                <h6 style={{ whiteSpace: 'pre-wrap' }}>{props.data.con_note || 'No notes available.'}</h6>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>
    );
};